import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PublicHeader } from '@/components/PublicHeader';
import { HeroSection } from '@/components/landing/HeroSection';
import { ValueProposition } from '@/components/landing/ValueProposition';
import { UseCases } from '@/components/landing/UseCases';
import { TestimonialsSection } from '@/components/landing/TestimonialsSection';
import { FinalCTASection } from '@/components/landing/FinalCTASection';
import { LandingFooter } from '@/components/landing/LandingFooter';
import { useSeo } from '@/hooks/useSeo';

const Landing = () => {
  const location = useLocation();

  useSeo({
    title: 'CampChef Pro — Camp meal planning & Sysco ordering',
    description:
      'Plan menus, track inventory, and order from Sysco — one calm system for camps, retreats, and outdoor programs.',
    path: '/',
    image: 'https://campchefpro.com/og/landing.png',
    imageWidth: 1216,
    imageHeight: 640,
    imageAlt: 'CampChef Pro — camp meal planning, made calm.',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'CampChef Pro',
        url: 'https://campchefpro.com',
        logo: 'https://szbvvvxyamindcuymrcr.supabase.co/storage/v1/object/public/brand-assets//horiz%20logo.png',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'sales',
          email: 'hello@campchefpro.com',
          areaServed: 'US',
          availableLanguage: 'English',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'CampChef Pro',
        url: 'https://campchefpro.com',
      },
    ],
  });

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-sand">
      <PublicHeader />
      <HeroSection />
      <ValueProposition />
      <UseCases />
      <TestimonialsSection />
      <FinalCTASection />
      <LandingFooter />
    </div>
  );
};

export default Landing;
